module.exports = __webpack_public_path__ + "static/media/black-graph.d383f1f8.jpg";